exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-container[data-v-26f26a40]{z-index:999;width:75%;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.slide-enter-active[data-v-26f26a40]{transition-duration:.1s;transition-timing-function:ease}.slide-enter-to[data-v-26f26a40],.slide-leave[data-v-26f26a40]{max-height:100px;overflow:hidden}.slide-enter[data-v-26f26a40],.slide-leave-to[data-v-26f26a40]{overflow:hidden;max-height:0}", ""]);

// exports
